import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import { ReportingDashboardControls } from 'teacher-ui-client/components/reporting/dashboard-controls'
import { ReportingDashboardDynamic } from 'teacher-ui-client/components/tiles/reporting-dashboard/dynamic'
import { DashboardTotalUsageOverTime } from 'teacher-ui-client/components/giraffe/charts/dashboard/total-usage-over-time'
import { t } from 'ember-intl'
import Component from '@glimmer/component'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import { themeKeys as statBoxThemes } from 'teacher-ui-client/components/giraffe/stat-box/themes'
import { camelize } from '@ember/string'
import { isPresent } from '@ember/utils'
import { action } from '@ember/object'
import type FastPhonicsDashboardChartRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/dashboard/index/route'
import { array } from '@ember/helper'
import { not } from 'ember-truth-helpers'
import RouteTemplate from 'ember-route-template'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'

interface Signature {
  Args: {
    model: ModelFor<FastPhonicsDashboardChartRoute>
  }
}
export class ReportingUiScopeFastPhonicsDashboardIndexPage extends Component<Signature> {
  @service router!: RouterService

  readonly totalUsageBoxes = [
    {
      category: 'lessons',
      theme: statBoxThemes.THEME_OCEANY_BLUE,
    },
    {
      category: 'quizzes',
      theme: statBoxThemes.THEME_JUICY_ORANGE,
      noClickAction: true,
    },
    {
      category: 'sounds',
      theme: statBoxThemes.THEME_PURPLY_PINK,
      noClickAction: true,
    },
    {
      category: 'words',
      theme: statBoxThemes.THEME_WL_BLUE,
      noClickAction: true,
    },
    {
      category: 'books',
      theme: statBoxThemes.THEME_GRAPEY_GREEN,
      noClickAction: true,
    },
  ]

  routePrefix = 'reporting.ui-scope.fast-phonics.dashboard'

  get isSummaryDataPresent() {
    return isPresent(this.args.model.totalUsageOverTime)
  }

  @action
  goToCategory(category: PropertyKey) {
    const paths: Record<PropertyKey, string | undefined> = {
      lessons: 'progress.review',
      // quizzes: '', // no link/report for these tiles yet
      // sounds: '',
      // words: '',
      // books: '',
    }
    const path = paths[category]

    if (path) void this.router.transitionTo(`reporting.ui-scope.fast-phonics.${path}`)
  }

  <template>
    <div class="mx-5">
      <ReportingTeacherUiHeader @title={{t "reporting.dashboardTitles.fastPhonics"}} />
      <span class="float-right print:hidden">
        <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-3 w-3 cursor-pointer" />
        <Tooltip @text={{t "reporting.dashboardTooltip"}} />
      </span>

      <ReportingDashboardControls
        @students={{@model.scopedStudents}}
        @routePrefix={{this.routePrefix}}
        @exportOptions={{array ExportType.print}}
        @isDataPresent={{this.isSummaryDataPresent}}
        @studentRouteName="reporting.ui-scope.fast-phonics.dashboard.student.table"
      />

      <ReportingDashboardDynamic
        data-test-total-usage-row
        @empty={{not this.isSummaryDataPresent}}
        @title={{t "reporting.chartTitles.dashboard.totalUsageOverTime"}}
        @tooltip={{t "reporting.tooltips.dashboard.totalUsageOverTime"}}
      >
        {{#if @model.totalUsageOverTime}}
          <DashboardTotalUsageOverTime
            @product={{@model.product}}
            @boxes={{this.totalUsageBoxes}}
            @data={{@model.totalUsageOverTime}}
            @tileClickAction={{this.goToCategory}}
            @uiScope={{camelize @model.uiScope.scope}}
          />
        {{/if}}
      </ReportingDashboardDynamic>
    </div>
  </template>
}

export default RouteTemplate(ReportingUiScopeFastPhonicsDashboardIndexPage)
